class SearchDrawer {
  constructor() {
    this.drawer = null;
    this.debounce = null;
    this.init();
  }

  init() {
    this.bindElements();
    this.bindEvents();
    document.addEventListener('shopify:section:load', () => {
      this.bindElements();
      this.bindEvents();
    });
  }

  bindElements() {
    this.drawer = document.getElementById('search-drawer');
    if (!this.drawer) return;

    this.overlay = this.drawer.querySelector('.search-drawer__overlay');
    this.closeBtn = this.drawer.querySelector('.search-drawer__close');
    this.searchInput = this.drawer.querySelector('#search-drawer-input');
    this.results = this.drawer.querySelector('#predictive-search-results');
    this.triggers = document.querySelectorAll('[data-search-trigger]');
  }

  bindEvents() {
    if (!this.drawer) return;

    this.triggers.forEach(trigger => {
      trigger.addEventListener('click', (e) => { e.preventDefault(); this.open(); });
    });

    this.closeBtn && this.closeBtn.addEventListener('click', (e) => { e.preventDefault(); this.close(); });
    this.overlay && this.overlay.addEventListener('click', (e) => { e.preventDefault(); this.close(); });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.drawer.classList.contains('active')) this.close();
    });

    if (this.searchInput) {
      this.searchInput.addEventListener('input', () => {
        clearTimeout(this.debounce);
        const q = this.searchInput.value.trim();
        if (q.length < 2) {
          if (this.results) { this.results.innerHTML = ''; this.results.classList.remove('active'); }
          return;
        }
        this.debounce = setTimeout(() => this.performSearch(q), 250);
      });
    }
  }

  performSearch(query) {
    if (!this.results) return;
    const base = '/search/suggest.json';
    const url =
      `${base}?q=${encodeURIComponent(query)}` +
      `&resources[type]=product` +
      `&resources[limit]=8` +
      `&resources[options][fields]=title,product_type,variants,price,compare_at_price,price_min,compare_at_price_min,featured_image` +
      `&resources[options][unavailable_products]=show` +
      `&resources[limit_scope]=each`;

    fetch(url, {
      method: 'GET',
      headers: { 'Accept': 'application/json' },
      credentials: 'same-origin',
      cache: 'no-store'
    })
    .then(r => { if (!r.ok) throw new Error(`HTTP ${r.status}`); return r.json(); })
    .then(data => this.displayResults(data))
    .catch(() => {
      this.results.innerHTML = '<div style="padding:15px;text-align:center;color:#666;">Suche konnte nicht durchgeführt werden</div>';
      this.results.classList.add('active');
    });
  }

  displayResults(data) {
    const products = data?.resources?.results?.products || data?.results?.products || [];
    if (!products.length) {
      this.results.innerHTML = '<div style="padding:15px;text-align:center;color:#666;">Keine Ergebnisse gefunden</div>';
      this.results.classList.add('active');
      return;
    }

    const html = products.map(p => {
      const title = p.title || '';
      const url = p.url || '#';
      const img = p.featured_image?.url || p.image?.url || p.image || '';
      const cents = this.toCents(p.price_min ?? p.price);
      const compare = this.toCents(p.compare_at_price_min ?? p.compare_at_price);
      const price = compare > cents
        ? `<div class="predictive-search-item__price"><span class="price-compare">${this.money(compare)}</span><span class="price-current">${this.money(cents)}</span></div>`
        : `<div class="predictive-search-item__price">${this.money(cents)}</div>`;
      return `
        <a href="${url}" class="predictive-search-item">
          ${img ? `<img src="${img}" alt="${this.esc(title)}" loading="lazy">` : '<div style="width:50px;height:50px;background:#f0f0f0;border-radius:8px;"></div>'}
          <div class="predictive-search-item__info">
            <div class="predictive-search-item__title">${this.esc(title)}</div>
            ${price}
          </div>
        </a>`;
    }).join('');

    this.results.innerHTML = html;
    this.results.classList.add('active');
  }

  toCents(v) {
    if (v == null) return 0;
    if (typeof v === 'number') return v >= 1000 ? Math.round(v) : Math.round(v * 100);
    const n = parseFloat(String(v).replace(/[^\d.,-]/g, '').replace(',', '.'));
    return isNaN(n) ? 0 : (n < 1000 ? Math.round(n * 100) : Math.round(n));
  }
  money(c){ return ((c||0)/100).toFixed(2).replace('.', ',') + ' €'; }
  esc(t){ const d=document.createElement('div'); d.textContent=String(t??''); return d.innerHTML; }

  open() {
    this.drawer.style.display = 'block';
    document.body.style.overflow = 'hidden';
    requestAnimationFrame(() => {
      this.drawer.classList.add('active');
      this.searchInput && this.searchInput.focus();
    });
  }

  close() {
    this.drawer.classList.remove('active');
    setTimeout(() => {
      this.drawer.style.display = 'none';
      document.body.style.overflow = '';
      if (this.results) {
        this.results.innerHTML = '';
        this.results.classList.remove('active');
      }
      if (this.searchInput) {
        this.searchInput.value = '';
      }
    }, 300);
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => new SearchDrawer());
} else {
  new SearchDrawer();
}